import React from 'react'
import {GoogleMap, InfoWindow, Marker, withGoogleMap} from "react-google-maps";
import PropTypes from 'prop-types'
import MarkerPopup from "./MarkerPopup";
import MarkerIcon from './marker.png'
import "./Map.scss"

const googleMaps = window.google.maps


//https://developers.google.com/maps/documentation/javascript/reference/marker#Icon
const icon = {
  url: MarkerIcon,
  scaledSize: new googleMaps.Size(54 * 0.5, 86 * 0.5)
};


const defaultZoom = 5;
const homeZoom = 12;
const defaultCenter = {lat: 41.9028, lng: 12.4964}

//https://developers.google.com/maps/documentation/javascript/controls
const GMAP_OPTIONS = {
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: true,
  fullscreenControl: true,
}

class Map extends React.Component {

  constructor(props) {
    super(props)
    this.state = {showInfo: false}
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeMarker !== this.props.activeMarker) {
      this.setState({showInfo: true})
    }
  }

  openInfo(marker) {
    this.props.setActiveMarker(marker)
    this.setState({showInfo: true})
  }

  closeInfo(marker) {
    this.setState({showInfo: false})
  }

  render() {
    const activeMarker = this.props.activeMarker
    const center = this.props.activeMarker ?
      {lat: activeMarker.LAT, lng: activeMarker.LNG} : defaultCenter

    return (
      <GoogleMap
        zoom={this.props.activeMarker ? homeZoom : defaultZoom}
        center={center}
        options={GMAP_OPTIONS}
      >
        {this.props.markers.map((marker, index) => (
          <Marker
            key={index}
            position={{lat: marker.LAT, lng: marker.LNG}}
            onClick={() => this.openInfo(marker)}
            icon={icon}
          >
            {this.props.activeMarker && this.props.activeMarker.ID === marker.ID && this.state.showInfo && (
              <InfoWindow onCloseClick={marker => this.closeInfo(marker)}>
                <MarkerPopup marker={marker}/>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    )
  }
}

Map.propTypes = {
  setActiveMarker: PropTypes.func.isRequired,
  activeMarker: PropTypes.object,
  home: PropTypes.object,
  markers: PropTypes.array.isRequired,
}

const MapWithGoogleMap = withGoogleMap(Map)

const MapWrapper = props => (
  <MapWithGoogleMap
    {...props}
    containerElement={<div style={{height: `100%`}}/>}
    mapElement={<div style={{height: `100%`}}/>}
  />
)

export default MapWrapper
